import type { Carer } from '@lmc/ts-common'
import { carerHomeIds } from './siteAccess'

export type StatusFilter = 'active' | 'inactive'

// Client-side filters applied on top of the tab + search + sort each team-list
// screen already does (CM-3581). Status maps to `carer.active`; site maps to the
// carer's resolved home ids. Empty arrays mean "no constraint for this facet".
export type TeamFilters = {
  statuses: StatusFilter[]
  siteIds: string[]
}

export const EMPTY_FILTERS: TeamFilters = { statuses: [], siteIds: [] }

// Total selected options across facets — drives the active-filter indicator on
// the Filters button.
export const countActiveFilters = (filters: TeamFilters): number =>
  filters.statuses.length + filters.siteIds.length

const matchesStatus = (carer: Carer, statuses: StatusFilter[]): boolean => {
  if (!statuses.length) {
    return true
  }
  return statuses.some((status) =>
    status === 'active' ? !!carer.active : !carer.active
  )
}

const matchesSite = (carer: Carer, siteIds: string[]): boolean => {
  if (!siteIds.length) {
    return true
  }
  const ids = new Set(carerHomeIds(carer))
  return siteIds.some((id) => ids.has(String(id)))
}

export const applyTeamFilters = (
  carers: Carer[],
  filters: TeamFilters
): Carer[] =>
  carers.filter(
    (carer) =>
      matchesStatus(carer, filters.statuses) &&
      matchesSite(carer, filters.siteIds)
  )
